// app入口文件
// 初始化 路由、样式、语言、store、全局配置global.json
import Vue from 'vue';

import router from './router';
import axios from 'main/common/ajax/config';
import store from 'main/store';

import 'normalize.css';
import ElementUI from 'element-ui';
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/scss/public.scss';
import 'vue2-animate/dist/vue2-animate.min.css';

import App from './App';

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(iView);

axios.get('static/config/global.json').then((res) => {
	let config = res.data;
	config.BASE_URL = (process.env.NODE_ENV === 'development')
		? config.DEV_BASE_URL
		: (process.env.NODE_ENV === 'local')
		? config.LOCAL_BASE_URL
		: config.BASE_URL;

	Vue.prototype.g_Config = config;
	axios.setConfig(Vue.prototype.g_Config);
	sessionStorage.setItem('picBaseUrl', config.BASE_URL);
	sessionStorage.setItem('REFRERSH_TOKEN_TIME', config.REFRERSH_TOKEN_TIME); // 刷新token时间
	sessionStorage.setItem('APPLICATION_TYPE', JSON.stringify(config.APPLICATION_TYPE)); // 刷新token时间

	/* eslint-disable no-new */
	window.vue = new Vue({
		el: '#app',
		router,
		store,
		template: '<App/>',
		components: {App}
	});
}).catch((err) => {
	console.log(err);
});



// WEBPACK FOOTER //
// ./main/main.js